/*
  Encuadre de las fotos en las tarjetas de producto (revisión 4 de Fantasía).
  Las fotos de los productos son cuadradas y traen mucho blanco arriba y abajo del colchón: en la vitrina se veía
  un espacio grande arriba. Este script mide, en una copia pequeña de cada foto, dónde está el producto (lo que
  no es blanco) y lo agranda para que ocupe todo el recuadro, centrado y sin cortarlo nunca. Arriba deja libre
  lo justo para la etiqueta de descuento (y obsequio), que va dentro de la foto: así no tapa el producto. Si la
  foto no es de fondo blanco (foto de ambiente), la deja llenando el recuadro. Sin JavaScript, la foto se ve completa.
*/
(() => {
  const SELECTOR = '.product-card-wrapper .card--block-media .media > img';
  const CACHE = 'fantasia-encuadre-v1';
  // Márgenes dentro del recuadro (fracción del alto o del ancho del recuadro).
  const ARRIBA = 0.05; // mínimo; si la tarjeta tiene etiqueta (% u obsequio), lo que ocupe la etiqueta
  const ABAJO = 0.05;
  const LADOS = 0.05;

  let memoria = {};
  try { memoria = JSON.parse(sessionStorage.getItem(CACHE) || '{}'); } catch (e) { memoria = {}; }
  const guardar = () => { try { sessionStorage.setItem(CACHE, JSON.stringify(memoria)); } catch (e) { /* sin espacio: no pasa nada */ } };

  const clave = (src) => {
    try { const u = new URL(src, location.href); return u.origin + u.pathname; } catch (e) { return src; }
  };

  const pendientes = new Map();
  const medir = (src) => {
    const k = clave(src);
    if (k in memoria) return Promise.resolve(memoria[k]);
    if (pendientes.has(k)) return pendientes.get(k);
    const p = new Promise((listo) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = () => {
        try {
          const w = 96;
          const h = Math.max(1, Math.round((w * img.naturalHeight) / img.naturalWidth));
          const lienzo = document.createElement('canvas');
          lienzo.width = w;
          lienzo.height = h;
          const ctx = lienzo.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, w, h);
          const d = ctx.getImageData(0, 0, w, h).data;
          let x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
              const i = (y * w + x) * 4;
              if (d[i + 3] > 24 && (d[i] < 236 || d[i + 1] < 236 || d[i + 2] < 236)) {
                if (x < x0) x0 = x;
                if (x > x1) x1 = x;
                if (y < y0) y0 = y;
                if (y > y1) y1 = y;
              }
            }
          }
          const r = x1 < 0 ? null : { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h, a: img.naturalWidth / img.naturalHeight };
          memoria[k] = r;
          guardar();
          listo(r);
        } catch (e) {
          listo(null);
        }
      };
      img.onerror = () => listo(null);
      try {
        const u = new URL(src, location.href);
        u.searchParams.set('width', '160');
        img.src = u.toString();
      } catch (e) {
        listo(null);
      }
    });
    pendientes.set(k, p);
    return p;
  };

  // Margen de arriba (fracción del alto del recuadro): lo justo para que la etiqueta, dentro de la foto, no tape el producto.
  const margenArriba = (img, caja, H) => {
    const etiqueta = img.closest('.card--block-media')?.querySelector('.card__badge');
    if (!etiqueta || !etiqueta.querySelector('.badge')) return ARRIBA;
    const borde = etiqueta.getBoundingClientRect().bottom - caja.getBoundingClientRect().top + 6;
    return borde > 0 ? Math.min(0.32, Math.max(ARRIBA, borde / H)) : ARRIBA;
  };

  const aplicar = (img, r) => {
    const caja = img.parentElement;
    if (!caja || !r) return;
    const W = caja.clientWidth;
    const H = caja.clientHeight;
    if (!W || !H) return;
    const B = W / H; // proporción del recuadro
    const cw = r.x1 - r.x0;
    const ch = r.y1 - r.y0;
    // Foto de ambiente (sin blanco alrededor): que llene el recuadro.
    if (cw > 0.96 && ch > 0.96) {
      img.classList.add('fantasia-encuadre--llena');
      img.classList.remove('fantasia-encuadre');
      img.removeAttribute('style');
      return;
    }
    const arribaLibre = margenArriba(img, caja, H);
    const altoLibre = 1 - arribaLibre - ABAJO;
    // Escala = ancho de la foto en anchos de recuadro. El producto cabe a lo ancho y a lo alto.
    const s = Math.min((1 - 2 * LADOS) / cw, (altoLibre * r.a) / (ch * B), 4);
    const altoFoto = (s * B) / r.a; // alto de la foto en altos de recuadro
    const cx = (r.x0 + r.x1) / 2;
    const cy = (r.y0 + r.y1) / 2;
    const izquierda = 0.5 - cx * s;
    const arriba = arribaLibre + altoLibre / 2 - cy * altoFoto;
    img.classList.add('fantasia-encuadre');
    img.style.width = `${(s * 100).toFixed(2)}%`;
    img.style.height = `${(altoFoto * 100).toFixed(2)}%`;
    img.style.left = `${(izquierda * 100).toFixed(2)}%`;
    img.style.top = `${(arriba * 100).toFixed(2)}%`;
  };

  const procesar = (img) => {
    if (img.dataset.fantasiaEncuadre === 'listo') return;
    const src = img.currentSrc || img.src;
    if (!src || src.startsWith('data:')) return;
    img.dataset.fantasiaEncuadre = 'listo';
    medir(src).then((r) => {
      if (r) {
        img.dataset.fantasiaRecorte = JSON.stringify(r);
        aplicar(img, r);
      }
    });
  };

  const revisar = (raiz) => raiz.querySelectorAll?.(SELECTOR).forEach(procesar);

  const iniciar = () => {
    revisar(document);
    // Tarjetas que llegan después (carruseles, filtros, «ver más», búsqueda).
    new MutationObserver((cambios) => {
      for (const c of cambios) {
        c.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches?.(SELECTOR)) procesar(n);
          else revisar(n);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
    // Si cambia el tamaño de la pantalla, se vuelve a calcular con la medida guardada.
    let espera;
    window.addEventListener('resize', () => {
      clearTimeout(espera);
      espera = setTimeout(() => {
        document.querySelectorAll('img[data-fantasia-recorte]').forEach((img) => aplicar(img, JSON.parse(img.dataset.fantasiaRecorte)));
      }, 150);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
